import { instance } from "api/apiBase";
import {
  PrescreeningTemplate,
  GetPrescreeningTemplatesResponse,
  PrescreeningTemplatePayload,
  RangesResponse,
  TemplateAvailabilityRule,
  ReplaceTemplateAvailabilityPayload,
  TemplateDateOverride,
  SetTemplateDateOverridePayload,
  RemoveTemplateDateOverridePayload
} from "./types";

const api = {
  getTemplates: async (
    page?: number,
    per_page?: number
  ): Promise<GetPrescreeningTemplatesResponse> => {
    return (
      await instance.get(`/portal/v1/boom_crm/prescreening_templates`, {
        params: { page, per_page }
      })
    ).data;
  },

  getTemplateById: async (id: number): Promise<PrescreeningTemplate> => {
    return (
      await instance.get(`/portal/v1/boom_crm/prescreening_templates/${id}`)
    ).data;
  },

  getTemplateByIdentifier: async (
    identifier: string
  ): Promise<PrescreeningTemplate> => {
    return (
      await instance.get(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}`
      )
    ).data;
  },

  createTemplate: async (
    data: PrescreeningTemplatePayload
  ): Promise<PrescreeningTemplate> => {
    return (
      await instance.post(`/portal/v1/boom_crm/prescreening_templates`, data)
    ).data;
  },

  updateTemplate: async (
    identifier: string,
    data: PrescreeningTemplatePayload
  ): Promise<PrescreeningTemplate> => {
    return (
      await instance.patch(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}`,
        data
      )
    ).data;
  },

  deleteTemplate: async (identifier: string): Promise<void> => {
    await instance.delete(
      `/portal/v1/boom_crm/prescreening_templates/${identifier}`
    );
  },

  getDefaultTemplate: async (): Promise<PrescreeningTemplate> => {
    return (
      await instance.get(`/portal/v1/boom_crm/prescreening_templates/default`)
    ).data;
  },

  setDefaultTemplate: async (
    identifier: string
  ): Promise<PrescreeningTemplate> => {
    return (
      await instance.post(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}/set_default`
      )
    ).data;
  },

  getRanges: async (): Promise<RangesResponse> => {
    return (
      await instance.get(`/portal/v1/boom_crm/prescreening_templates/ranges`)
    ).data;
  },

  getAvailability: async (
    identifier: string
  ): Promise<TemplateAvailabilityRule[]> => {
    return (
      await instance.get(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}/availability`
      )
    ).data;
  },

  replaceAvailability: async (
    identifier: string,
    data: ReplaceTemplateAvailabilityPayload
  ): Promise<TemplateAvailabilityRule[]> => {
    return (
      await instance.put(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}/availability`,
        data
      )
    ).data;
  },

  getDateOverrides: async (
    identifier: string
  ): Promise<TemplateDateOverride[]> => {
    return (
      await instance.get(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}/date_overrides`
      )
    ).data;
  },

  setDateOverride: async (
    identifier: string,
    data: SetTemplateDateOverridePayload
  ): Promise<TemplateDateOverride[]> => {
    return (
      await instance.put(
        `/portal/v1/boom_crm/prescreening_templates/${identifier}/date_overrides`,
        data
      )
    ).data;
  },

  removeDateOverride: async (
    identifier: string,
    data: RemoveTemplateDateOverridePayload
  ): Promise<void> => {
    await instance.delete(
      `/portal/v1/boom_crm/prescreening_templates/${identifier}/date_overrides`,
      { data }
    );
  }
};

export default api;
